// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_FormatRawPreview__scroll {
  margin-bottom: 1.2em;
  height: 6em;
  overflow: auto;
  border-radius: 0.4em;
  background: #404040;
  color: #f0f0f0;
}
.CSVImporter_FormatRawPreview__pre {
  margin: 0;
  padding: 0.5em 1em;
  line-height: 1.25;
  font-size: 1.15em;
}
.CSVImporter_FormatRawPreview__pre > aside {
  display: inline-block;
  margin-left: 0.2em;
  padding: 0 0.25em;
  border-radius: 0.2em;
  background: #fff;
  font-size: 0.75em;
  color: #808080;
  opacity: 0.75;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/file-step/FormatRawPreview.scss","webpack://./theme.scss"],"names":[],"mappings":"AAGE;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,oBCOW;EDNX,mBCFc;EDGd,cCJgB;ADEpB;AAKE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBCpBW;EDqBX,iBAAA;EACA,cCvBe;EDwBf,aAAA;AAHN","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_FormatRawPreview {\n  &__scroll {\n    margin-bottom: 1.2em;\n    height: 6em;\n    overflow: auto;\n    border-radius: $borderRadius;\n    background: $invertedBgColor;\n    color: $invertedTextColor;\n  }\n\n  &__pre {\n    margin: 0; // override default\n    padding: 0.5em 1em;\n    line-height: 1.25;\n    font-size: 1.15em;\n\n    & > aside {\n      display: inline-block;\n      margin-left: 0.2em;\n      padding: 0 0.25em;\n      border-radius: $borderRadius * 0.5;\n      background: $controlBgColor;\n      font-size: 0.75em;\n      color: $controlBorderColor;\n      opacity: 0.75;\n    }\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
